export function composeMessage(fields: {
  from: string;
  to: string;
  roundTrip: boolean;
  depart?: string;
  returnDate?: string;
  freeText: string;
  transportModes?: ("car" | "train" | "plane")[];
  maxDrivingHours?: number;
}): string {
  const from = fields.from.trim();
  const to = fields.roundTrip ? from : fields.to.trim();

  let route = "";
  if (from && to && to !== from) {
    route = `from ${from} to ${to}`;
  } else if (from && fields.roundTrip) {
    route = `from ${from} and back`;
  } else if (from) {
    route = `from ${from}`;
  }

  let tripType = "";
  if (to && to !== from) {
    tripType = " This is a one-way trip.";
  } else if (fields.roundTrip) {
    tripType = " This is a round trip — return to origin.";
  }

  let dates = "";
  if (fields.depart && fields.returnDate) {
    dates = ` from ${fields.depart} to ${fields.returnDate}`;
  } else if (fields.depart) {
    dates = ` starting ${fields.depart}`;
  }

  const modes = fields.transportModes ?? ["car"];
  const maxH = fields.maxDrivingHours ?? 4;

  let modeList: string;
  if (modes.length === 1) {
    modeList = modes[0];
  } else if (modes.length === 2) {
    modeList = `${modes[0]} and ${modes[1]}`;
  } else {
    modeList = `${modes.slice(0, -1).join(", ")}, and ${modes[modes.length - 1]}`;
  }
  let travelPrefs = ` Travel by ${modeList}`;
  if (modes.includes("car")) {
    travelPrefs += `, max ${maxH}h driving per day`;
  }
  travelPrefs += ".";

  const freeText = fields.freeText.trim();

  const parts = [
    route ? `Planning a trip ${route}` : "Planning a road trip",
    dates,
    ".",
    tripType,
    travelPrefs,
    freeText ? ` Interests: ${freeText}` : "",
  ];

  return parts.join("").replace(/\.\.+/g, ".").replace(/\s+/g, " ").trim();
}
